import { removeLastRefreshTime } from "./indexDbStorage";

export const SELECTED_SITE = "selectedSite";
export const SHOW_PLAN_DESCRIPTION = "showPlanDescription";

export const setSelectedSite = (value) => {
  window.localStorage.setItem(SELECTED_SITE, value);
};

export const getSelectedSite = () => {
  return window.localStorage.getItem(SELECTED_SITE);
};

export const getShowPlanDescription = () => {
  const value = window.localStorage.getItem(SHOW_PLAN_DESCRIPTION);
  if (value === null) return true;
  return value === "true";
};

export const setShowPlanDescription = (value) => {
  window.localStorage.setItem(SHOW_PLAN_DESCRIPTION, String(value));
};

export const removeSession = () => {
  removeLastRefreshTime();
};

export const CLEAR_STORAGE_TIME = "clearStorageTime";

export const setClearStorageTime = (value) => {
  window.localStorage.setItem(CLEAR_STORAGE_TIME, value);
};

export const getClearStorageTime = () => {
  return window.localStorage.getItem(CLEAR_STORAGE_TIME);
};

export const removeClearStorage = () => {
  window.localStorage.clear();
  const time = new Date().getTime();
  setClearStorageTime(time);
};
